import { schema } from 'normalizr';
import city from './city';
import tag from './tag';
import tip from './tip';
import user from './user';

const story = new schema.Entity(
  'story',
  {
    owner: user,
    city,
    cuisinesTags: [tip],
    dishes: [tag],
    eateriesTags: [tag],
    tags: [tag],
  },
  { idAttribute: 'linkTitle' }
);

export default story;
